exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".visually-hidden[data-v-d4381e74]{position:absolute!important;height:1px;width:1px;overflow:hidden;clip:rect(1px,1px,1px,1px);white-space:nowrap}.app-chip[data-v-d4381e74]{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;padding:.5rem 1rem;border-radius:999px;border:1px solid #ccc;background-color:#fff;color:#333;cursor:pointer;transition:all .2s ease;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.app-chip.active[data-v-d4381e74]{background-color:#4caf50;color:#fff;border-color:#4caf50}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d4381e74","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/uikit/components/AppChip/AppChip.vue
// module id = 02c57e299f8cb6ae48bd
// module chunks = 12